import React from 'react'

export default function AppointmentEditor({initialState, onDataChanged, props}) {
    return <div>
        <hr/>
        <h5 className="hotspot-setting-header">Appointment</h5>
        <div className="hotspot-setting-info">
            Now users will be able to book appointments with you.
        </div>
    </div>
}
